/**
 * The entry point. Story VC-016.
 *
 * Three lines of React and one decision: `StrictMode` is *off*.
 *
 * That is not the usual choice and it is not laziness. StrictMode mounts
 * every effect twice in development, which for a page holding a live stream
 * means two of it — and the second is torn down while the first is still
 * negotiating. The real double-mount hazards StrictMode exists to catch are
 * handled where they live: every effect here returns a teardown.
 *
 * The original reason was stronger and is worth keeping in view for when the
 * voice layer returns (V2-091): two microphones, two WebSockets and two
 * `AudioContext`s produce bugs in the browser's device layer rather than in
 * this code, and chasing them teaches nothing about the session.
 */

import { createRoot } from "react-dom/client";

import { App } from "./App.jsx";
import "./theme/app.css";
import "./theme/screens.css";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(<App />);
}
